import { FC } from 'react';
import { Button, Modal, Typography } from 'antd';
import { useNotificationContext } from '@/features/notifications';
import { useRemoveShareKey } from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { Col, Row } from '@/shared/ui';

type Props = {
  open: boolean;
  refetchOrganization: () => void;
  onSuccess: () => void;
  onCancel: () => void;
};

const { Title } = Typography;

export const OrganizationRemoveShareableLinkModal: FC<Props> = ({
  open,
  refetchOrganization,
  onSuccess,
  onCancel,
}) => {
  const { activeOrganization } = useRouterContext();
  const { showNotification } = useNotificationContext();

  const { mutate: removeShareKey, isLoading: removeShareKeyLoading } =
    useRemoveShareKey();

  const handleShareKeyDelete = () => {
    removeShareKey(
      { pathParams: { id: activeOrganization?.id! } },
      {
        onSuccess: () => {
          refetchOrganization();
          showNotification({
            message: 'Success',
            description: 'Shareable link removed',
            type: 'success',
          });
          onSuccess();
        },
        onError: (error: any) => {
          showNotification({
            message: 'Error',
            description:
              error?.message || error.stack.message || 'Something went wrong',
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Modal
      title={
        <Col
          alignItems="flex-start"
          style={{ margin: '10px 0', width: '100%' }}
        >
          <Title level={4} style={{ lineHeight: 1, marginTop: 15 }}>
            Remove Shareable link
          </Title>
        </Col>
      }
      width={350}
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      onCancel={onCancel}
    >
      <div style={{ marginTop: 20 }}>
        Are you sure you want to remove shareable link?
        <br />
        <br />
        Users with this link will no longer have access to organization
        published procs page.
      </div>
      <Row>
        <Button
          onClick={onCancel}
          style={{ width: '40%', height: 40, marginTop: 30 }}
        >
          Cancel
        </Button>
        <Button
          danger
          type="primary"
          loading={removeShareKeyLoading}
          onClick={handleShareKeyDelete}
          style={{ width: '60%', height: 40, marginTop: 30 }}
        >
          Delete
        </Button>
      </Row>
    </Modal>
  );
};
